import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

export enum TemplateUnit {
  Day = 1,
  Month = 3,
}

export enum TemplateFieldType {
  System = 1,
  Custom = 3,
  SystemDisplay = 5,
}

export enum TemplateFieldDataType {
  Text = 1,
  Number = 3,
  Boolean = 9,
}

export const TemplateFieldTypeOptions = [
  {
    label: i18n.t("systemParameter"),
    value: TemplateFieldType.System,
  },
  {
    label: i18n.t("customizationParameter"),
    value: TemplateFieldType.Custom,
  },
  {
    label: i18n.t("customizationParameter"),
    value: TemplateFieldType?.SystemDisplay,
  },
];

export const TemplateFieldTypeMap = getMapObjectFromArray(
  TemplateFieldTypeOptions
);

export enum SystemFieldGroupDataText {
  BenefitInKind = "BENEFIT_IN_KIND",
  Allowance = "ALLOWANCE",
  EmployeeData = "EMPLOYEE_DATA",
  PayrollSetting = "PAYROLL_SETTING",
  Earning = "EARNING",
  InsuranceData = "INSURANCE_DATA",
  PitData = "PIT_DATA",
  Deduction = "DEDUCTION",
  TimeAttendance = "TIME_ATTENDANCE",
  PITData = "PIT_DATA",
  SHUI_EMPLOYEE = "SHUI_EMPLOYEE",
  SHUI_EMPLOYER = "SHUI_EMPLOYER",
}

export const SystemFieldGroupDataTextOption = [
  {
    label: i18n.t("sideBarEarning"),
    value: SystemFieldGroupDataText.Earning,
  },
  {
    label: i18n.t("sideBarDeduction"),
    value: SystemFieldGroupDataText.Deduction,
  },
  {
    label: i18n.t("sideBarAllowance"),
    value: SystemFieldGroupDataText.Allowance,
  },
  {
    label: i18n.t("benefitInKind"),
    value: SystemFieldGroupDataText.BenefitInKind,
  },
  {
    label: i18n.t("pit"),
    value: SystemFieldGroupDataText.PITData,
  },
  {
    label: i18n.t("shuiEmployee"),
    value: SystemFieldGroupDataText.SHUI_EMPLOYEE,
  },
  {
    label: i18n.t("shuiEmployer"),
    value: SystemFieldGroupDataText.SHUI_EMPLOYER,
  },
];

export const SystemFieldGroupDataTextMap = getMapObjectFromArray(
  SystemFieldGroupDataTextOption
);
